module.exports = __webpack_public_path__ + "static/img/Ellipse 123.0a11579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 123.png
// module id = Ct/R
// module chunks = 1